// Upload progress handler for direct uploads
// Track active uploads globally
const activeUploads = new Map();

document.addEventListener("DOMContentLoaded", function() {
  // Handle direct upload events
  document.addEventListener("direct-upload:initialize", function(event) {
    const { target, detail } = event;
    const { id, file } = detail;

    // Track this upload
    activeUploads.set(id, { status: 'initializing', file: file });
    updateSubmitButtonState(target);

    // Create progress element
    const progressContainer = document.createElement('div');
    progressContainer.className = 'mt-2 p-2 border rounded bg-light';
    progressContainer.id = `direct-upload-${id}`;

    const fileName = document.createElement('div');
    fileName.className = 'small fw-bold mb-1';
    fileName.textContent = file.name;

    const progressBar = document.createElement('div');
    progressBar.className = 'progress';
    progressBar.style.height = '8px';

    const progressBarFill = document.createElement('div');
    progressBarFill.className = 'progress-bar bg-success';
    progressBarFill.setAttribute('role', 'progressbar');
    progressBarFill.style.width = '0%';

    const progressText = document.createElement('small');
    progressText.className = 'text-muted d-block mt-1';
    progressText.textContent = 'Preparing upload...';

    progressBar.appendChild(progressBarFill);
    progressContainer.appendChild(fileName);
    progressContainer.appendChild(progressBar);
    progressContainer.appendChild(progressText);

    // Find or create progress container area
    let progressArea = target.parentNode.querySelector('.upload-progress-area');
    if (!progressArea) {
      progressArea = document.createElement('div');
      progressArea.className = 'upload-progress-area';
      target.parentNode.insertBefore(progressArea, target.nextSibling);
    }
    progressArea.appendChild(progressContainer);
  });

  document.addEventListener("direct-upload:start", function(event) {
    const { id } = event.detail;
    activeUploads.set(id, { ...activeUploads.get(id), status: 'uploading' });

    const progressContainer = document.getElementById(`direct-upload-${id}`);
    if (progressContainer) {
      const progressText = progressContainer.querySelector('small');
      progressText.textContent = 'Starting upload...';
    }
  });

  document.addEventListener("direct-upload:progress", function(event) {
    const { id, progress } = event.detail;
    const progressContainer = document.getElementById(`direct-upload-${id}`);
    if (progressContainer) {
      const progressBarFill = progressContainer.querySelector('.progress-bar');
      const progressText = progressContainer.querySelector('small');

      progressBarFill.style.width = `${progress}%`;
      progressText.textContent = `Uploading... ${Math.round(progress)}%`;
    }
  });

  document.addEventListener("direct-upload:error", function(event) {
    const { id, error } = event.detail;
    activeUploads.set(id, { ...activeUploads.get(id), status: 'error' });

    const progressContainer = document.getElementById(`direct-upload-${id}`);
    if (progressContainer) {
      const progressBar = progressContainer.querySelector('.progress-bar');
      const progressText = progressContainer.querySelector('small');

      progressBar.className = 'progress-bar bg-danger';
      progressText.textContent = `Upload failed: ${error}`;
      progressText.className = 'text-danger d-block mt-1';

      // Keep error message visible, don't auto-remove
      progressContainer.classList.add('border-danger');
    }

    // Find the file input from the progress container
    const fileInput = findFileInputForUpload(progressContainer);
    updateSubmitButtonState(fileInput);
  });

  document.addEventListener("direct-upload:end", function(event) {
    const { id } = event.detail;
    activeUploads.set(id, { ...activeUploads.get(id), status: 'complete' });

    const progressContainer = document.getElementById(`direct-upload-${id}`);
    if (progressContainer) {
      const progressBarFill = progressContainer.querySelector('.progress-bar');
      const progressText = progressContainer.querySelector('small');

      progressBarFill.style.width = '100%';
      progressText.textContent = 'Upload complete!';
      progressText.className = 'text-success d-block mt-1';

      // Remove progress bar after 3 seconds
      setTimeout(() => {
        if (progressContainer.parentNode) {
          activeUploads.delete(id);
          progressContainer.remove();

          // Update button state after removing completed upload
          const fileInput = findFileInputForUpload(progressContainer);
          updateSubmitButtonState(fileInput);
        }
      }, 3000);
    }

    // Find the file input from the progress container
    const fileInput = findFileInputForUpload(progressContainer);
    updateSubmitButtonState(fileInput);
  });

  // Handle file selection to show file info
  document.addEventListener('change', function(event) {
    const target = event.target;
    if (target.matches('input[type="file"][data-direct-upload-url]')) {
      const files = target.files;
      if (files.length > 0) {
        // Show selected files count
        let fileInfo = target.parentNode.querySelector('.file-info');
        if (!fileInfo) {
          fileInfo = document.createElement('small');
          fileInfo.className = 'text-muted d-block mt-1 file-info';
          target.parentNode.appendChild(fileInfo);
        }

        if (files.length === 1) {
          const fileSize = (files[0].size / 1024 / 1024).toFixed(2);
          fileInfo.textContent = `Selected: ${files[0].name} (${fileSize} MB)`;
        } else {
          const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);
          const totalSizeMB = (totalSize / 1024 / 1024).toFixed(2);
          fileInfo.textContent = `Selected: ${files.length} files (${totalSizeMB} MB total)`;
        }
      }
    }
  });
});

// Helper function to find the form's submit button
function findSubmitButton(fileInput) {
  if (!fileInput) return null;
  const form = fileInput.closest('form');
  return form ? form.querySelector('input[type="submit"], button[type="submit"]') : null;
}

// Helper function to find the file input from a progress container
function findFileInputForUpload(progressContainer) {
  if (!progressContainer) return null;
  const progressArea = progressContainer.closest('.upload-progress-area');
  if (!progressArea && progressArea.previousElementSibling) {
    return progressArea.previousElementSibling.matches('input[type="file"]')
      ? progressArea.previousElementSibling
      : null;
  }
  // Fallback: try to find file input in parent
  const parent = progressContainer.closest('.mb-4');
  return parent ? parent.querySelector('input[type="file"]') : null;
}

// Update submit button state based on active uploads
function updateSubmitButtonState(fileInput) {
  const submitButton = findSubmitButton(fileInput);
  if (!submitButton) return;

  // Check if any uploads are in progress or have errors
  const hasActiveUploads = Array.from(activeUploads.values()).some(
    upload => upload.status === 'uploading' || upload.status === 'initializing'
  );
  const hasErrors = Array.from(activeUploads.values()).some(
    upload => upload.status === 'error'
  );

  if (hasActiveUploads) {
    submitButton.disabled = true;
    const originalText = submitButton.dataset.originalText || submitButton.value || submitButton.textContent;
    if (!submitButton.dataset.originalText) {
      submitButton.dataset.originalText = originalText;
    }
    if (submitButton.tagName === 'INPUT') {
      submitButton.value = 'Uploading files...';
    } else {
      submitButton.textContent = 'Uploading files...';
    }
  } else if (hasErrors) {
    submitButton.disabled = true;
    const originalText = submitButton.dataset.originalText || submitButton.value || submitButton.textContent;
    if (!submitButton.dataset.originalText) {
      submitButton.dataset.originalText = originalText;
    }
    if (submitButton.tagName === 'INPUT') {
      submitButton.value = 'Fix upload errors to continue';
    } else {
      submitButton.textContent = 'Fix upload errors to continue';
    }
  } else {
    submitButton.disabled = false;
    const originalText = submitButton.dataset.originalText;
    if (originalText) {
      if (submitButton.tagName === 'INPUT') {
        submitButton.value = originalText;
      } else {
        submitButton.textContent = originalText;
      }
      delete submitButton.dataset.originalText;
    }
  }
}